import UserAccountResource  from 'resources/user/UserAccountResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class InvoiceResource extends UserAccountResource {
  static urlRoot = '/invoices'
}
